import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SoldOutBodyMessage } from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage';
import { SoldOutBase } from 'components/Unavailability/SoldOut/SoldOutBase';
import { Button } from '@daedalus/atlas/Button';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => Button;
const ChangeDatesButton = /*#__PURE__*/styled(_exp())({
  name: "ChangeDatesButton",
  class: "c2cqtbj",
  propsAsIs: true
});
interface Props {
  handleChangeDatesClick?: (event: React.MouseEvent) => void;
  hasCompactButton?: boolean;
}
export const UnavailabilityWithChangeDates: React.FC<Props> = ({
  handleChangeDatesClick,
  hasCompactButton = false
}) => {
  return <SoldOutBase headerSlot={<FormattedMessageWrapper id="unavailability.soldout" defaultMessage="Sold out on your dates" />} contentSlot={<SoldOutBodyMessage />} actionSlot={handleChangeDatesClick && <ChangeDatesButton variant="secondary" fullWidth className={cx(!hasCompactButton && '__marginTop')} onClick={handleChangeDatesClick}>
            <FormattedMessageWrapper id="changeDates" defaultMessage="Change dates" />
          </ChangeDatesButton>} />;
};

require("./UnavailabilityWithChangeDates.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./UnavailabilityWithChangeDates.tsx");